/* LCDF phase16 v2. Early fresh-action listener; verified working runtime IDs.
   Shopify Customer Privacy API + Usercentrics V3 dedicated purpose services only.
   No cookies, dataLayer, logs, analytics calls, sale_of_data or GPC mutation. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.EMAShopifyPurposeBridge = api;
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var SHOP = '07a943-df.myshopify.com', SETTING = '3vON4N-3KVaeQM';
  var PURPOSES = {
    analytics: { name: 'Shopify Analytics', template_id: 'ZQOx-TM97Y3rLe' },
    marketing: { name: 'Shopify Marketing', template_id: 'zixK7I8y1mhf1D' },
    preferences: { name: 'Shopify Preferences', template_id: 'T4PQQdTkrEofhd' }
  };
  function own(o, k) { return !!o && Object.prototype.hasOwnProperty.call(o, k); }
  function object(o) { return !!o && typeof o === 'object' && !Array.isArray(o); }
  function configValid(config) {
    if (!object(config) || config.enabled !== true || config.shop !== SHOP || config.setting_id !== SETTING || !object(config.services)) return false;
    var ids = [];
    return Object.keys(PURPOSES).every(function (purpose) {
      var p = own(config.services, purpose) && config.services[purpose], expected = PURPOSES[purpose];
      if (!object(p) || p.template_id !== expected.template_id || typeof p.runtime_service_id !== 'string' || !p.runtime_service_id.trim()) return false;
      if (ids.indexOf(p.runtime_service_id) >= 0) return false;
      ids.push(p.runtime_service_id); return true;
    });
  }
  function project(details, config) {
    if (!configValid(config)) return null;
    if (!object(details) || !own(details, 'consent') || !own(details, 'services')) return null;
    var c = details.consent, services = details.services, result = {};
    // A saved/initial decision is not a fresh visitor interaction. Do not write
    // stale defaults on load or turn an unknown missing purpose into consent.
    if (!object(c) || !own(c, 'type') || c.type !== 'EXPLICIT' || !own(c, 'fromUserAction') || c.fromUserAction !== true ||
      !own(c, 'setting') || !object(c.setting) || !own(c.setting, 'id') || c.setting.id !== SETTING || !own(c.setting, 'type') || c.setting.type !== 'GDPR' || !object(services)) return null;
    var valid = Object.keys(PURPOSES).every(function (purpose) {
      var id = config.services[purpose].runtime_service_id, service = own(services, id) && services[id];
      if (!object(service) || !own(service, 'name') || service.name !== PURPOSES[purpose].name ||
        !own(service, 'consent') || !object(service.consent) || !own(service.consent, 'given') ||
        typeof service.consent.given !== 'boolean' || !own(service.consent, 'type') || service.consent.type !== 'EXPLICIT') return false;
      result[purpose] = service.consent.given; return true;
    });
    return valid ? result : null;
  }
  function install(global, config) {
    if (!configValid(config) || !global || (global.Shopify && global.Shopify.shop !== SHOP)) return { status: function () { return 'disabled_or_unverified'; } };
    var pending = null, busy = false, loading = false, state = 'waiting_for_visitor', stopped = false, latestVerified = true;
    function matches(privacy, consent) {
      try { var actual = privacy.currentVisitorConsent(); return Object.keys(consent).every(function (key) { return own(actual, key) && actual[key] === (consent[key] ? 'yes' : 'no'); }); } catch (_) { return false; }
    }
    function flush() {
      if (stopped || busy || !pending) return;
      if (!global.Shopify) { state = 'waiting_for_shopify'; return; }
      if (global.Shopify.shop !== SHOP) {
        pending = null; stopped = true; state = 'shop_mismatch'; removeListeners(); return;
      }
      var privacy = global.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
        if (loading) { state = 'waiting_for_api'; return; }
        if (typeof global.Shopify.loadFeatures !== 'function') { state = 'api_unavailable'; return; }
        loading = true; state = 'waiting_for_api';
        try { global.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          loading = false;
          if (stopped) return;
          if (error) { state = 'api_unavailable'; return; }
          if (!global.Shopify.customerPrivacy || typeof global.Shopify.customerPrivacy.setTrackingConsent !== 'function') { state = 'api_unavailable'; return; }
          flush();
        }); } catch (_) { loading = false; state = 'api_unavailable'; }
        return;
      }
      var consent = pending; pending = null;
      if (matches(privacy, consent)) { state = latestVerified ? 'synced' : 'unverified_event'; return; }
      busy = true; state = 'syncing';
      try { privacy.setTrackingConsent(consent, function () {
        busy = false;
        if (stopped) return;
        // The documented callback has no error contract. Verify saved choices;
        // an HTTP/callback acknowledgement alone is not a successful sync.
        state = !latestVerified ? 'unverified_event' : matches(privacy, consent) ? 'synced' : 'sync_mismatch';
        flush();
      }); } catch (_) { busy = false; state = 'sync_failed'; flush(); }
    }
    function onConsent(event) {
      if (stopped) return;
      var next = project(event && event.detail, config);
      latestVerified = !!next;
      if (!next) {
        // Never replay a queued grant after an unverified update. Preserve only
        // false purposes from a prior fresh validated action (Shopify supports
        // partial updates), so a legitimate queued withdrawal is not discarded.
        var denials = {};
        if (pending) Object.keys(pending).forEach(function (key) { if (pending[key] === false) denials[key] = false; });
        pending = Object.keys(denials).length ? denials : null; state = 'unverified_event';
        if (pending) flush(); return;
      }
      pending = next; flush();
    }
    function onBootstrap() { flush(); }
    function removeListeners() {
      global.removeEventListener('UC_CONSENT', onConsent);
      global.removeEventListener('load', onBootstrap);
      if (global.document && typeof global.document.removeEventListener === 'function') global.document.removeEventListener('DOMContentLoaded', onBootstrap);
    }
    global.addEventListener('UC_CONSENT', onConsent);
    global.addEventListener('load', onBootstrap);
    if (global.document && typeof global.document.addEventListener === 'function') global.document.addEventListener('DOMContentLoaded', onBootstrap);
    return {
      status: function () { return state; },
      stop: function () { stopped = true; pending = null; state = 'stopped'; removeListeners(); }
    };
  }
  return Object.freeze({ project: project, install: install });
});

/* Working LCDF-only install. Load synchronously BEFORE GTM/CMP can become interactive.
   No initial reads/writes: only validated fresh UC_CONSENT visitor actions. */
(function (w) {
  'use strict';
  if (!w || !w.location || w.location.hostname !== 'lacasadellafibra.com' || w.EMALcdfNativeConsentBridge || !w.EMAShopifyPurposeBridge) return;
  var c = {"enabled":true,"shop":"07a943-df.myshopify.com","setting_id":"3vON4N-3KVaeQM","services":{"analytics":{"template_id":"ZQOx-TM97Y3rLe","runtime_service_id":"ZQOx-TM97Y3rLe"},"marketing":{"template_id":"zixK7I8y1mhf1D","runtime_service_id":"zixK7I8y1mhf1D"},"preferences":{"template_id":"T4PQQdTkrEofhd","runtime_service_id":"T4PQQdTkrEofhd"}}};
  w.EMALcdfNativeConsentBridge = w.EMAShopifyPurposeBridge.install(w, c);
})(typeof window === 'undefined' ? null : window);
